import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = { class: "min-w-0 flex-1" }
const _hoisted_3 = { class: "block truncate text-[13px] font-bold leading-tight" }
const _hoisted_4 = { class: "setup-badge__sub block truncate text-[11px] font-medium leading-tight" }
const _hoisted_5 = { class: "setup-badge__count flex h-5 min-w-[1.25rem] items-center justify-center px-1.5 text-[11px] font-extrabold" }

import { CheckIcon } from '@heroicons/vue/24/solid'
import { computed } from 'vue'

import { setupBadgeCopy } from '@/components/setup/setupSurfaceCopy'
import { useSetupSurface } from '@/components/setup/useSetupSurface'


export default {
  __name: 'SetupBadge',
  setup(__props) {

const { visible, surface, isOpen, toggle } = useSetupSurface()

const copy = computed(() => setupBadgeCopy(surface.value))

// Literal class strings: these are hand-written scoped rules, and the sidebar is
// dark enough that it never touches the catering-* tokens the rest of the drawer
// is built from. The colour follows the stamp and the tick follows the live
// count, so a store in the queue whose Stripe fell over keeps its calm colour and
// gets its number back.
const badgeClass = computed(() => {
  if (surface.value.pendingReview) return 'setup-badge--review'
  return surface.value.complete ? 'setup-badge--done' : 'setup-badge--todo'
})

return (_ctx, _cache) => {
  return (_unref(visible))
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: _normalizeClass(["setup-badge relative flex w-full items-center gap-2.5 overflow-hidden rounded-md px-3 py-2 text-left font-manrope", [badgeClass.value, _unref(isOpen) && 'setup-badge--open']]),
        "aria-expanded": _unref(isOpen),
        "aria-haspopup": "dialog",
        onClick: _cache[0] || (_cache[0] = (...args) => (_unref(toggle) && _unref(toggle)(...args)))
      }, [
        _cache[1] || (_cache[1] = _createElementVNode("span", {
          class: "setup-badge__dot",
          "aria-hidden": "true"
        }, null, -1)),
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(copy.value.title), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(copy.value.subtitle), 1)
        ]),
        _createElementVNode("span", _hoisted_5, [
          (_unref(surface).complete)
            ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                key: 0,
                class: "h-3 w-3"
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_unref(surface).outstanding), 1)
              ], 64))
        ])
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}
}

}